import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const EMPTY = '-';

export const formatDateTime = (iso?: string | null): string => {
  if (!iso) return EMPTY;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return EMPTY;
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  return formatInTimeZone(date, timeZone, 'MMM d, h:mm a zzz');
};

export const formatDay = (iso: string | null | undefined): string =>
  iso ? format(new Date(iso), 'MMM d') : '';

export const formatMoney = (cents: number): string =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

export const formatPercent = (
  rate?: number | null,
  digits: number = 1,
): string => {
  if (rate === null || rate === undefined || Number.isNaN(rate)) return EMPTY;
  return `${(rate * 100).toFixed(digits)}%`;
};
